import * as fromPostDataActions from '../../+state/actions/post-data.action';
import { PaxTypeCodes } from '../../constants/common.constants';
import { PriceTypes } from '../../constants/postData.constants';
import { Redirect_search_routes } from '../../constants/urls.constants';
import {
  Passenger,
  PostDataSearchLocalStorage
} from '../../models/postData-search-local-storage.interface';
import { UpdateSearchApiPayload } from '../../models/states/update-search-state.interfaces';

export const prepareUpdateSearchApiPayload = (
  postData: PostDataSearchLocalStorage
): UpdateSearchApiPayload | null => {
  try {
    const [segment] = postData.segments;
    const { adtCount, passengerCount } = getPassengerCountInformation(
      postData.passengers
    );
    const payload: UpdateSearchApiPayload = {
      //TODO: configure this from predictive search api
      airports: {
        fromCity: segment.originCity,
        toCity: segment.destinationCity,
        fromAirportcode: segment.origin,
        toAirportcode: segment.destination,
        invalidAirportCodes: null
      },
      selectTripType: postData.tripType,
      dates: {
        departureDate: getDateInMMDDYYFormat(segment.departureDate),
        returnDate: segment.returnDate
          ? getDateInMMDDYYFormat(segment.returnDate)
          : '',
        chkFlexDate: postData.datesFlexible
      },
      deltaOnly: 'off',
      departureTime: '',
      returnTime: '',
      passenger: passengerCount,
      schedulePrice: { value: postData.shopType || '' },
      faresFor: postData.bestFare,
      awardTravel: postData.priceType === PriceTypes.AWARD,
      chkFlexDate: postData.datesFlexible,
      meetingEventCode: postData.meetingEventCode,
      nearbyAirports: postData.flexAirport,
      refundableFlightsOnly: postData.refundableFlightsOnly,
      adtCount,
      adtGbeCount: 0,
      cnnCount: 0,
      infantCount: 0,
      includeBasicFaresUnchecked: postData.includeBasicFaresUnchecked
    };
    return payload;
  } catch (error) {
    // TODO: Track error in trackjs
    return null;
  }
};

export const getPassengerCountInformation = (passengers: Passenger[]) => {
  let adtCount = 0;
  passengers.forEach((passenger) => {
    if (passenger.type === PaxTypeCodes.ADULT) {
      adtCount = adtCount + Number(passenger.count);
    }
  });
  const passengerCount = adtCount;
  return { adtCount, passengerCount };
};
export const getDateInMMDDYYFormat = (dateToConvert: string) => {
  if (dateToConvert) {
    const [year, month, day] = dateToConvert.split('-');
    return `${month}/${day}/${year}`;
  } else {
    return '';
  }
};

export const handleUpdateSearchApiFailure = (
  redirectToPage: Redirect_search_routes,
  cacheKeySuffix: string
) => {
  return fromPostDataActions.ReadyToNavigateSearch({
    redirectToPage,
    cacheKeySuffix
  });
};
